module.exports = __webpack_public_path__ + "static/assets/dfffae66f4a57806d99b490b385319bc.gif";